import { optional } from '@/lib/dom'

const COPIED_CLASS = 'is-active'
const FEEDBACK_MS = 2000

/** クリップボード API が使えない環境向けのフォールバック */
function legacyCopy(text: string): boolean {
  const area = document.createElement('textarea')
  area.value = text
  area.setAttribute('readonly', '')
  area.style.position = 'fixed'
  area.style.opacity = '0'
  document.body.appendChild(area)
  area.select()

  let ok = false
  try {
    ok = document.execCommand('copy')
  } catch {
    ok = false
  }
  document.body.removeChild(area)
  return ok
}

/** `#copy-url` を押したら現在の URL をクリップボードへコピーする。 */
export function initShare(): void {
  const button = optional('#copy-url')
  if (!button) return

  const label = optional('p', button)
  const originalLabel = label?.innerHTML ?? ''
  let timer: number | undefined

  button.setAttribute('role', 'button')
  button.setAttribute('tabindex', '0')

  const notify = (message: string): void => {
    if (!label) return
    label.textContent = message
    window.clearTimeout(timer)
    timer = window.setTimeout(() => {
      label.innerHTML = originalLabel
      button.classList.remove(COPIED_CLASS)
    }, FEEDBACK_MS)
  }

  const copy = async (): Promise<void> => {
    const url = window.location.href
    let ok = false

    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(url)
        ok = true
      } catch {
        ok = legacyCopy(url)
      }
    } else {
      ok = legacyCopy(url)
    }

    button.classList.toggle(COPIED_CLASS, ok)
    notify(ok ? 'Copyしました' : 'Copyできませんでした')
  }

  button.addEventListener('click', () => {
    void copy()
  })

  button.addEventListener('keydown', (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      void copy()
    }
  })
}
